import {Box} from "@mui/material";
import FieldsContentUnteraufgabe from "./FieldsContentUnteraufgabe";
import {useUnteraufgabenHandling} from "../../hooks/unteraufgaben/useUnteraufgabenHandling";
import {Mandant, Unteraufgabe} from "../../api";
import {DEFAULT_LANGUAGE} from "../../config/language";

interface UnteraufgabeItemProps {
    unteraufgabe: Unteraufgabe;
    sprache?: string;
    mandant: Mandant;
    index: number;
    remove: (index: number) => void;
}

export default function UnteraufgabeItem({unteraufgabe, sprache = DEFAULT_LANGUAGE, mandant, index, remove}: UnteraufgabeItemProps) {
    const {
        canEditUnteraufgabeField,
    } = useUnteraufgabenHandling();

    return (
        <Box
            display="flex"
            gap={2}
            flex={1}
        >

                <FieldsContentUnteraufgabe
                    canEditFields={canEditUnteraufgabeField(mandant?.id ?? "")}
                    reihenfolge={index}
                    unteraufgabe={unteraufgabe}
                    sprache={sprache}
                    remove={remove}
                />
        </Box>
    );
}